import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../Layout/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import PdfUploader from '../Layout/Upload/PdfUploader';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Login from "../auth/Login";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

export default function Upload() {
  const handleUploadSuccess = (url, fileName) => {
  };

  const handleUploadError = (error) => {
    console.error('Upload error:', error);
  };


  return (
    <>
      <AuthenticatedTemplate>


        <div className='h-screen overflow-y-scroll'>
          <div id="homePage" style={{ position: "relative" }}>
            <Box className="mainLayout" sx={{ display: "flex", overflow: "hidden" }}>
              <MainLayout />
              <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
                <DrawerHeader />
                <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />
                <div id="mainHome">
                  <div>
                    <div className="mt-[-30px] bg-gray-100 flex flex-col items-center justify-center p-4">
                      <div className="w-full  mb-8 text-center mt-5">
                        <div className="flex justify-center mb-2">
                          <div className="bg-blue-600 p- rounded-full">
                            {/* <FileText className="h-8 w-8 text-white" /> */}
                          </div>
                        </div>
                        <h1 className="font-bold text-lg text-gray-800 mb-2">Please upload financial documents exclusively related to the following companies:</h1>
                        <p className="text-gray-600 text-sm mb-10">
                          Campbell Soup, Coca-Cola, Colgate-Palmolive, CVS Group, Danone, General Mills, Hershey, IDEXX, J.M. Smucker, Kellanova, Kraft Heinz, McCORMICK, Mondelez, Nestle, PepsiCo, Unilever.
                          Uploading documents pertaining to other entities is not permitted.
                        </p>
                      </div>

                      <PdfUploader
                        onUploadSuccess={handleUploadSuccess}
                        onUploadError={handleUploadError}
                        containerName="files"
                      />

                      <div className="mt-8 text-sm text-gray-500 max-w-md text-center">
                        <p>
                          Only PDF files are accepted.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Box>
            </Box>
          </div>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>

  );

}





